import axios from 'axios'
import sha1 from 'sha1'
import Base64 from 'base-64';

let appInfo = getAppInfo()
const api = 'https://sys.sumfen.com/api/'


function getAppInfo() {
    return {
        ids: 'sys',
        keys: 'F0OhEJ6jma5oJboR'
    }
}

function getUToken() {
    var userInfo = getUserInfo()
    if (!userInfo.utoken) {
        return ''
    }
    return userInfo.utoken
}

export function getUserInfo() {
    let userInfo: any = window.localStorage.getItem('userInfo')
    try {
        userInfo = JSON.parse(userInfo)
        if (userInfo) {
            return userInfo
        } else {
            return {
                user: {}
            }
        }
    } catch (e) {
        return {
            user: {}
        }
    }

}

function getAppkey() {
    var now = Date.now()
    var key = appInfo.keys
    var id = appInfo.ids
    var appKey = Base64.encode(id + '.' + sha1(id + 'APP' + key + 'APP' + now) + '.' + now)
    return appKey
}


export function getUid() {
    var userInfo = getUserInfo()
    if (userInfo.id) {
        return userInfo.id
    } else {
        return ''
    }
}


export const sfAjax = {
    get(url: string, params: any) {
        return new Promise((resolve, reject) => {

            // 上面的请求也可以这样做
            axios.get(api + url, {
                headers: {
                    'Authori-zation': 'Bearer ' + getAppkey(),
                    'UID': getUid(),
                    'UTOKEN': getUToken()
                },
                params: params
            })
                .then(function (response) {
                    resolve(response.data)
                    console.log(response);
                })
                .catch(function (error) {
                    reject(error)
                    console.log(error);
                });
        })

    },
    post(url: string, params: any) {
        return new Promise((resolve, reject) => {

            // 上面的请求也可以这样做
            axios.post(api + url, params, {
                headers: {
                    'Authori-zation': 'Bearer ' + getAppkey(),
                    'UID': getUid(),
                    'UTOKEN': getUToken()
                }
            })
                .then(function (response) {
                    resolve(response.data)
                    console.log(response);
                })
                .catch(function (error) {
                    reject(error)
                    console.log(error);
                });
        })

    }
}
